  (function () {
    function isCarouselMode() {
      return window.matchMedia('(max-width: 749px)').matches;
    }

    function slideStep(track) {
      var col = track.querySelector('.collection-landing__three-col');
      if (!col) return Math.round(track.clientWidth * 0.85);
      var gap = parseFloat(window.getComputedStyle(track).gap) || 0;
      return col.getBoundingClientRect().width + gap;
    }

    function updateNav(track, prev, next) {
      if (!prev || !next) return;
      if (!isCarouselMode()) {
        prev.disabled = true;
        next.disabled = true;
        return;
      }
      var maxScroll = track.scrollWidth - track.clientWidth;
      prev.disabled = track.scrollLeft <= 1;
      next.disabled = track.scrollLeft >= maxScroll - 1;
    }

    function findActiveThreeColumn(track) {
      var cols = track.querySelectorAll('.collection-landing__three-col');
      if (!cols.length) return null;
      var mid = track.scrollLeft + track.clientWidth * 0.5;
      var i;
      for (i = 0; i < cols.length; i++) {
        var c = cols[i];
        var cl = c.offsetLeft;
        var cr = cl + c.offsetWidth;
        if (mid >= cl && mid < cr) return c;
      }
      var best = cols[0];
      var bestDist = Infinity;
      for (i = 0; i < cols.length; i++) {
        var c = cols[i];
        var cMid = c.offsetLeft + c.offsetWidth * 0.5;
        var d = Math.abs(mid - cMid);
        if (d < bestDist) {
          bestDist = d;
          best = c;
        }
      }
      return best;
    }

    function positionThreeNavOnFirstImage(root, track, nav) {
      if (!nav) return;
      if (!isCarouselMode()) {
        nav.style.top = '';
        nav.style.transform = '';
        return;
      }
      var col = findActiveThreeColumn(track);
      if (!col) return;
      var img = col.querySelector('.collection-landing__three-col-images .collection-landing__three-img');
      if (!img || !img.getBoundingClientRect().height) return;
      var imgR = img.getBoundingClientRect();
      var rootR = root.getBoundingClientRect();
      var centerY = imgR.top + imgR.height * 0.5 - rootR.top;
      nav.style.top = centerY + 'px';
      nav.style.transform = 'translateY(-50%)';
    }

    function initCarousel(root) {
      var track = root.querySelector('[data-matcha-three-track]');
      var prev = root.querySelector('[data-matcha-three-prev]');
      var next = root.querySelector('[data-matcha-three-next]');
      var nav = root.querySelector('.collection-landing__three-nav');
      if (!track || !prev || !next) return;

      var scrollBehavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
      prev.addEventListener('click', function () {
        if (!isCarouselMode()) return;
        track.scrollBy({ left: -slideStep(track), behavior: scrollBehavior });
      });
      next.addEventListener('click', function () {
        if (!isCarouselMode()) return;
        track.scrollBy({ left: slideStep(track), behavior: scrollBehavior });
      });

      function syncNav() {
        updateNav(track, prev, next);
        positionThreeNavOnFirstImage(root, track, nav);
      }

      track.addEventListener('scroll', syncNav);
      window.addEventListener('resize', syncNav);

      var dragging = false;
      var ptrId = null;
      var startX = 0;
      var startScroll = 0;

      track.addEventListener('pointerdown', function (e) {
        if (!isCarouselMode()) return;
        if (e.pointerType === 'touch') return;
        if (e.button !== 0) return;
        dragging = true;
        ptrId = e.pointerId;
        startX = e.clientX;
        startScroll = track.scrollLeft;
        track.classList.add('is-grabbing');
        try {
          track.setPointerCapture(e.pointerId);
        } catch (err) {}
      });

      track.addEventListener('pointermove', function (e) {
        if (!dragging || e.pointerId !== ptrId) return;
        track.scrollLeft = startScroll - (e.clientX - startX);
        if (isCarouselMode()) syncNav();
      });

      function endDrag(e) {
        if (!dragging) return;
        if (e && e.pointerId !== ptrId) return;
        dragging = false;
        ptrId = null;
        track.classList.remove('is-grabbing');
        if (e) {
          try {
            track.releasePointerCapture(e.pointerId);
          } catch (err) {}
        }
      }

      track.addEventListener('pointerup', endDrag);
      track.addEventListener('pointercancel', endDrag);

      function bootNav() {
        syncNav();
      }
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', bootNav);
      } else {
        bootNav();
      }
      requestAnimationFrame(bootNav);
      setTimeout(bootNav, 200);
      setTimeout(bootNav, 600);

      if (window.ResizeObserver && nav) {
        var ro = new ResizeObserver(function () {
          syncNav();
        });
        ro.observe(root);
        ro.observe(track);
      }

      track.querySelectorAll('.collection-landing__three-img').forEach(function (im) {
        if (im.complete) return;
        im.addEventListener('load', syncNav, { once: true });
      });
    }

    document.querySelectorAll('[data-matcha-three-carousel]').forEach(initCarousel);
  })();
